import React from "react"
import { Card, Grid, Icon } from "semantic-ui-react"
import { formatCurrency } from "uikit"
import { NavLink } from "react-router-dom"
import "./GenericCard.css"

const SocialSecurity = ({
  id,
  description,
  ownerName,
  monthly_amount,
  type
}) => (
  <Card>
    <Card.Content>
      <Grid style={{ position: "relative", height: "170px" }}>
        <Grid.Row columns={2} verticalAlign="top">
          <Grid.Column>
            <NavLink
              to={`/organize/income+benefits/incomes/${id}/${type.toLowerCase()}`}
              className="navlink"
            >
              <span className="GenericCard__LinkTitle">
                Social Security
                <Icon name="chevron right" size="small" />
              </span>
            </NavLink>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="GenericCard__Balance">
              {typeof monthly_amount === "number"
                ? formatCurrency(monthly_amount)
                : monthly_amount}
            </p>
            <p className="greyed-text">Monthly</p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2} verticalAlign="bottom">
          <Grid.Column>
            <p className="greyed-text">{ownerName}</p>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="greyed-text">Income Benefit</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
)

export default SocialSecurity
